import { AxiosResponse } from "axios";
import { Base } from "./bases/base.service";

export default class MyCourseService {
  public getMyCourse(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get("my-course/get", { params });
  }
  public getMyCourseDetail(slug: string): Promise<AxiosResponse<any>> {
    return Base().get(`my-course/detail/${slug}`);
  }
  public submitAssessment(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("my-course/assessment/submit", params);
  }
  public setContent(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("my-course/set/content", params);
  }
  public setRating(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("my-course/set/rating", params);
  }
  public getCertificate(id: number): Promise<AxiosResponse<any>> {
    return Base().get(`my-course/certificate/${id}`, {
      responseType: "blob",
    });
  }
}
